// assets/custom-webengage-events.js

// -------------------------------------------------------------------------
// 1. HELPER FUNCTIONS (Define these FIRST)
// -------------------------------------------------------------------------
function webengageOnReady(callback) {
  if (typeof window.webengage === 'undefined' || typeof window.webengage.onReady !== 'function') {
    setTimeout(function() { webengageOnReady(callback); }, 100);
  } else {
    window.webengage.onReady(callback);
  }
}

// ... (getProductDataFromCard helper function as defined before) ...
function getProductDataFromCard(formElement) {
  const cardWrapper = formElement.closest('.card-wrapper.product-card-wrapper');
  if (!cardWrapper) return null;
  const data = {};
  const productTitleLink = cardWrapper.querySelector('.card__heading a');
  const firstImage = cardWrapper.querySelector('.card__media img');
  data.productId = formElement.querySelector('input[name="product-id"]')?.value;
  data.variantId = formElement.querySelector('input[name="id"].product-variant-id')?.value;
  data.title = productTitleLink ? productTitleLink.innerText.trim() : 'N/A';
  data.image = firstImage ? firstImage.src : '';
  const currentPriceElement = cardWrapper.querySelector('#current-price .money, .price-item--regular .money');
  if (currentPriceElement) {
    data.price = parseFloat(currentPriceElement.innerText.replace(/[^0-9.]/g, ''));
  } else {
    data.price = 0;
  }
  const selectedVariantPackElement = cardWrapper.querySelector('.selected-variant-pack');
  data.variantTitle = selectedVariantPackElement ? selectedVariantPackElement.innerText.trim() : 'N/A';
  const ratingElement = cardWrapper.querySelector('.jdgm-prev-badge[data-average-rating]');
  data.ratings = ratingElement ? `${ratingElement.dataset.averageRating} stars` : "N/A";
  data.category = cardWrapper.dataset.productCategory || 'N/A';
  data.product_type = cardWrapper.dataset.productType || 'N/A';
  data.vendor = cardWrapper.dataset.productVendor || 'N/A';
  data.tags = cardWrapper.dataset.productTags ? cardWrapper.dataset.productTags.split(',') : [];
  data.collections = cardWrapper.dataset.productCollections ? cardWrapper.dataset.productCollections.split(',') : [];
  return data;
}


// -------------------------------------------------------------------------
// 2. QUINN SHOPPABLE VIDEO APP EVENT LISTENER (As is)
// -------------------------------------------------------------------------
window.addEventListener("onquinnevents", (e) => {
  // ... (Quinn listener code as previously defined) ...
  const { eventName, data: quinnData } = e.detail;
  const userType = window.WE_USER_TYPE || 'guest';

  webengageOnReady(function() {
    switch (eventName) {
      case "product_viewed":
        console.log("Quinn - Product viewed:", quinnData);
        if (quinnData && quinnData.id) {
          let selectedVariant = quinnData.selected_variant || (quinnData.variants && quinnData.variants.length > 0 ? quinnData.variants[0] : null);
          if (!selectedVariant && quinnData.id) {
              selectedVariant = {
                  id: quinnData.variant_id || quinnData.id, price: quinnData.price,
                  available: quinnData.available !== undefined ? quinnData.available : true,
                  name: quinnData.variant_title || quinnData.title,
                  featured_image: quinnData.featured_image ? { src: quinnData.featured_image } : null
              };
          }
          const reelProductPayload = {
            product_name: quinnData.title,
            available: selectedVariant ? selectedVariant.available : quinnData.available,
            currency: window.ShopifyCurrency || 'INR', id: quinnData.id.toString(),
            image: selectedVariant && selectedVariant.featured_image ? selectedVariant.featured_image.src : quinnData.featured_image,
            price: selectedVariant && typeof selectedVariant.price !== 'undefined' ? (selectedVariant.price / 100) : (typeof quinnData.price !== 'undefined' ? (quinnData.price / 100) : 0),
            ratings: "N/A", source: 'quinn_reel', tags: quinnData.tags || [], title: quinnData.title,
            total_variants: quinnData.variants ? quinnData.variants.length : (selectedVariant ? 1 : 0),
            variant_id: selectedVariant ? selectedVariant.id.toString() : undefined,
            user_type: userType, category: quinnData.type || (quinnData.product_type || "Unknown")
          };
          for (const key in reelProductPayload) { if (reelProductPayload[key] === undefined) delete reelProductPayload[key]; }
          window.webengage.track('reel_product_viewed', reelProductPayload);
        }
        break;
      case "widget_clicked":
        console.log("Quinn - Widget clicked:", quinnData);
        break;
    }
  });
});


// -------------------------------------------------------------------------
// Function to initialize GoKwik Cart Event Tracking for WebEngage
// -------------------------------------------------------------------------
let gokwikSubscriptionAttempted = false;

function initGoKwikWebEngageTracking() {
  if (gokwikSubscriptionAttempted) {
    console.log("GoKwik subscription already attempted/initialized via this function call.");
    // Check current status if needed again, or simply return
    if (typeof analytics !== 'undefined' && typeof analytics.subscribe === 'function') {
        console.log("Re-check: 'analytics.subscribe' IS available.");
    } else {
        console.log("Re-check: 'analytics.subscribe' is STILL NOT available.");
    }
    return;
  }
  gokwikSubscriptionAttempted = true; // Set flag to prevent multiple subscriptions from this specific flow

  console.log("Attempting to initialize GoKwik WebEngage tracking (initGoKwikWebEngageTracking called)...");
  const userType = window.WE_USER_TYPE || 'guest';
  const currentCurrency = window.ShopifyCurrency || 'INR';

  if (typeof analytics !== 'undefined') {
    console.log("DEBUG: 'analytics' object IS DEFINED at the time of initGoKwikWebEngageTracking.");
    if (typeof analytics.subscribe === 'function') {
      console.log("DEBUG: 'analytics.subscribe' IS a function. Attempting to subscribe to 'kwik-cart-event'.");
      try {
        analytics.subscribe("kwik-cart-event", event => {
          console.log("GoKwik Cart Event Raw Details: ", JSON.parse(JSON.stringify(event)));

          const eventName = event?.eventName || event?.name || event?.type || event?.action;
          const eventData = event?.data || event?.detail || event?.payload || event;
          console.log(`GoKwik Event Received - Name: ${eventName}, Data:`, JSON.parse(JSON.stringify(eventData)));

          webengageOnReady(function() {
            // --- Logic for cart_viewed ---
            if (eventName === 'cart viewed') { // <--- VERIFY THIS
              // ... (cart_viewed payload and track call as defined in previous response)
              // Remember to use eventData to populate payload if possible, else fetch /cart.js
              // Example: const cartDetails = eventData?.cart || eventData;
              // window.webengage.track('cart_viewed', cartViewedPayload);
              console.log("WebEngage: cart_viewed event would be tracked here.");
            }

            // --- Logic for add_to_cart_custom (from inside cart) ---
            if (eventName === 'PLEASE_REPLACE_WITH_ACTUAL_GOKWIK_ITEM_ADDED_EVENT_NAME') { // <--- VERIFY THIS
              // ... (add_to_cart_custom payload and track call as defined in previous response)
              // Example: const itemData = eventData?.item || eventData?.product || eventData;
              // window.webengage.track('add_to_cart_custom', atcInsideCartPayload);
              console.log("WebEngage: add_to_cart_custom (inside_cart) event would be tracked here.");
            }
          });
        });
        console.log("SUCCESS: Subscribed to GoKwik 'kwik-cart-event'. Waiting for events...");
      } catch (e) {
        console.error("ERROR: Failed to subscribe to GoKwik 'kwik-cart-event'. Error:", e);
      }
    } else {
      console.warn("DEBUG: 'analytics.subscribe' is NOT a function. Typeof analytics.subscribe:", typeof analytics.subscribe);
      console.log("DEBUG: Current 'analytics' object structure:", analytics);
    }
  } else {
    console.warn("DEBUG: 'analytics' object is UNDEFINED at the time of initGoKwikWebEngageTracking.");
    // Let's check for other potential GoKwik global objects that might have event systems
    if (typeof window.GoKwik === 'object' && window.GoKwik !== null) {
        console.log("DEBUG: Found 'window.GoKwik' object:", window.GoKwik);
        if (window.GoKwik.events && typeof window.GoKwik.events.subscribe === 'function') {
            console.log("DEBUG: Suggestion - Try 'GoKwik.events.subscribe'");
        } else if (typeof window.GoKwik.subscribe === 'function') {
            console.log("DEBUG: Suggestion - Try 'GoKwik.subscribe'");
        }
    }
    if (typeof window.gkCart === 'object' && window.gkCart !== null) {
        console.log("DEBUG: Found 'window.gkCart' object:", window.gkCart);
        if (window.gkCart.events && typeof window.gkCart.events.subscribe === 'function') {
            console.log("DEBUG: Suggestion - Try 'gkCart.events.subscribe'");
        } else if (typeof window.gkCart.on === 'function') {
            console.log("DEBUG: Suggestion - Try 'gkCart.on'");
        }
    }
  }
}


// -------------------------------------------------------------------------
// MAIN SCRIPT EXECUTION (DOM Ready, GoKwik Ready)
// -------------------------------------------------------------------------
document.addEventListener('DOMContentLoaded', function() {
  console.log("DOM Content Loaded. Setting up general event listeners.");
  const userType = window.WE_USER_TYPE || 'guest';
  const currentCurrency = window.ShopifyCurrency || 'INR';

  // --- Event: top_navigation_clicked ---
  // ... (your top_navigation_clicked code as previously defined) ...
  webengageOnReady(function() {
    const mainNavigationLinks = document.querySelectorAll(
      '.header__inline-menu a.header__menu-item, .menu-drawer__menu a.menu-drawer__menu-item'
    );
    function getSectionFromLink(linkElement) {
        let sectionText = 'unknown_section';
        const desktopTopLevelParent = linkElement.closest('nav.header__inline-menu > ul.list-menu > li');
        const mobileTopLevelParent = linkElement.closest('nav.menu-drawer__navigation > ul.menu-drawer__menu > li');
        if (desktopTopLevelParent) {
            const topLevelLinkOrSummary = desktopTopLevelParent.querySelector(':scope > a, :scope > header-menu > details > summary');
            if (topLevelLinkOrSummary) sectionText = topLevelLinkOrSummary.innerText.trim().split('\n')[0] || 'main_menu';
        } else if (mobileTopLevelParent) {
            const topLevelLinkOrSummary = mobileTopLevelParent.querySelector(':scope > a, :scope > details > summary');
            if (topLevelLinkOrSummary) sectionText = topLevelLinkOrSummary.innerText.trim().split('\n')[0] || 'main_menu';
        }
        return sectionText;
    }
    mainNavigationLinks.forEach(link => {
      link.addEventListener('click', function(e) {
        let label = this.innerText.trim().split('\n')[0];
        const section = getSectionFromLink(this);
        const href = this.href || this.closest('a')?.href;
        if (href) {
            window.webengage.track('top_navigation_clicked', {
              section: section, label: label, user_type: userType, target_url: href
            });
        }
      });
    });
  });

  // --- Event: footer_link_clicked ---
  // ... (your footer_link_clicked code, including lab_report_explored logic, as previously defined) ...
  webengageOnReady(function() {
    const footerLinks = document.querySelectorAll(
      '.footer-block ul.list-unstyled a, .footer__list-social a, .footer__copyright a'
    );
    footerLinks.forEach(link => {
      link.addEventListener('click', function() {
        const label = this.innerText.trim() || this.href;
        let section = 'Unknown Footer Section';
        const footerBlock = this.closest('.footer-block.grid__item');
        if (footerBlock) {
          const headingElement = footerBlock.querySelector('.footer-block__heading');
          if (headingElement) section = headingElement.innerText.trim();
        } else if (this.closest('.footer__list-social')) {
          section = 'Follow Us';
        } else if (this.closest('.footer__copyright')) {
          section = 'Copyright';
        }
        let eventName = 'footer_link_clicked';
        let payload = { section: section, label: label, user_type: userType, target_url: this.href };
        // if (this.href && this.href.includes('/pages/lab-test-reports')) {
        //   eventName = 'lab_report_explored'; payload.label = 'Lab Reports Page';
        // }
        window.webengage.track(eventName, payload);
      });
    });
  });

  // --- Event: whatsapp_button_clicked ---
  // ... (your whatsapp_button_clicked code as previously defined) ...
  webengageOnReady(function() {
    const whatsappButton = document.querySelector('#sy-whatshelp a.sywh-open-services');
    if (whatsappButton) {
      whatsappButton.addEventListener('click', function() {
        window.webengage.track('whatsapp_button_clicked', { user_type: userType, target_url: this.href });
      });
    }
  });

  // --- Event: add_to_cart_custom (Homepage Featured Collection) ---
  // ... (your add_to_cart_custom for homepage code as previously defined, using getProductDataFromCard) ...
   webengageOnReady(function() {
    const atcFormsHomepage = document.querySelectorAll(
      '#shopify-section-template--18913065599206__featured_collection product-form form[data-type="add-to-cart-form"]'
    );
    atcFormsHomepage.forEach(form => {
      form.addEventListener('submit', function(event) {
        const productData = getProductDataFromCard(this);
        if (!productData || !productData.productId || !productData.variantId) return;
        const atcPayload = {
          category: productData.category || "N/A",
          collections: productData.collections && productData.collections.length > 0 ? productData.collections : ["N/A"],
          currency: currentCurrency, image: productData.image, price: productData.price, ratings: productData.ratings,
          product_id: productData.productId.toString(), atc_type: 'homepage_featured_collection',
          product_type: productData.product_type || "N/A", quantity: 1, source: 'homepage',
          tags: productData.tags && productData.tags.length > 0 ? productData.tags : ["N/A"],
          title: productData.title, variant_id: productData.variantId.toString(),
          variant_title: productData.variantTitle, user_type: userType, vendor: productData.vendor || "N/A"
        };
        window.webengage.track('add_to_cart_custom', atcPayload);
      });
    });
  });

});


// -------------------------------------------------------------------------
// MAIN SCRIPT EXECUTION
// -------------------------------------------------------------------------
document.addEventListener('DOMContentLoaded', function() {
  console.log("DOM Content Loaded. Main WebEngage custom event script part running.");
  // ... (your other event listeners like top_navigation_clicked, footer_link_clicked, homepage ATC, etc. - Keep these as they are)
  
  // Initial attempt for GoKwik, though gokwikLoaded is preferred
  console.log("DOMContentLoaded: Calling initGoKwikWebEngageTracking (initial attempt).");
  initGoKwikWebEngageTracking(); // Call it once here
});

// Listen for the gokwikLoaded event specifically for GoKwik integrations
window.addEventListener('gokwikLoaded', () => {
  console.log('gokwikLoaded event has FIRED. Calling initGoKwikWebEngageTracking again (preferred method).');
  // Reset the flag so it can attempt subscription again if the first one (from DOMContentLoaded) failed before GoKwik was ready
  gokwikSubscriptionAttempted = false;
  initGoKwikWebEngageTracking();
});

console.log("Custom WebEngage event script initialized. Awaiting DOMContentLoaded and gokwikLoaded events.");

